module.exports = __webpack_public_path__ + "img/linkedin.899efe4e.png";